import { APIParser } from "./api-parser";
import { NEW_API_URL } from "./api-client";
import { saveAs } from "file-saver";
import { createFetchGetOptions, getToken } from "./api-util.js";
import { config } from "../../util/axios-config";
import triyoAPI from "./triyo.js";

export const AddProject = (project) => {
  return triyoAPI.post(`/projects/AddProject`, project, config("POST"));
};

export const GetUserProjects = (userId) => {
  let token = getToken();
  let myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);

  let requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  return fetch(
    NEW_API_URL + "projects/getuserprojects/" + userId,
    requestOptions
  ).then((response) => APIParser(response));
};

export const GetProjectNEWAPI = (projectID) => {
  return triyoAPI.get(`/projects/GetProject/${projectID}`, config());
};

export const GetBlankProjectQuery = () => {
  return new Promise((resolve, reject) => {
    resolve({
      pageSize: 10,
      pageNumber: 1,
      sortDesc: true,
      sortBy: "",
      filters: [],
    });
  });
};

export const GetProjectsNEWAPI = () => {
    return triyoAPI.get(`/projects/GetProjects`, config());
};

export const GetProjectsWithFilters = (data) => {
    const query = JSON.stringify(data);
    return triyoAPI.post(`/projects/GetProjectsWithFilters`, query, config("POST", true));
};

export const GetTopTenProjectsWithFilters = (data) => {
    const query = JSON.stringify(data);
    return triyoAPI.post(`/projects/GetTopTenProjectsWithFilters`, query, config("POST", true));
};

export const EditProjectNEWAPI = (data) => {
    return triyoAPI.patch(`/projects/EditProject`, data, config("PATCH"));
};

export const EditProjectWithTaskDueDateExtensionAPI = (data) => {
    return triyoAPI.patch(`/projects/EditProjectWithTaskDueDateExtension`, data, config("PATCH"));
};

export const EditProjectStatus = (data) => {
    return triyoAPI.patch(`/projects/EditProjectStatus`, data, config("PATCH"));
};

export const EditProjectMembers = (data) => {
    return triyoAPI.patch(`/projects/EditProjectMembers`, data, config("PATCH"));
};

export const GetProjectsCountByUser = (userId) => {
    return triyoAPI.get(`/projects/GetProjectsCountByUser/${userId}`, config());
};

export const GetProjectsUsersAndGroups = () => {
    return triyoAPI.get(`/projects/GetProjectsUsersAndGroups`, config());
};

// TAD-5849: Automations-only variant — also returns groups that have no members
// (Members = []), so they stay selectable in In-Form Automations availability.
export const GetProjectsUsersAndGroupsForAutomations = () => {
    return triyoAPI.get(`/projects/GetProjectsUsersAndGroupsForAutomations`, config());
};

export const GetProjectDocument = (documentID, documentName) => {
  return fetch(
    NEW_API_URL + "projects/getprojectdocument/" + documentID,
    createFetchGetOptions()
  )
    .then((response) => response.text())
    .then(async (result) => {
      let fileExtensionStr =
        documentName
          .toLowerCase()
          .substring(documentName.lastIndexOf(".") + 1, documentName.length) ||
        documentName;
      let fileFormatStr = "";

      if (fileExtensionStr === "pptx") {
        fileFormatStr =
          "data:application/vnd.openxmlformats-officedocument.presentationml.presentation;base64";
      } else {
        fileFormatStr =
          "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64";
      }

      let resultT = result.replaceAll(`"`, "");

      if (resultT) {
        const blob = await (await fetch(`${fileFormatStr},${resultT}`)).blob();
        saveAs(blob, documentName);
      } else {
        console.log("File download error");
      }
    })
    .catch((error) => console.log("File download error: ", error));
};

export const UploadProjectDocument = (
  file,
  projectId,
  fileType,
  documentId,
  fileName
) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("projectId", projectId);
  formData.append("fileType", fileType);
  formData.append("fileName", fileName);
  formData.append("documentId", documentId);

  let token = getToken();
  let myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);

  let requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formData,
    redirect: "follow",
  };

  return fetch(NEW_API_URL + "projects/AddProjectFile/", requestOptions).then(
    (response) => APIParser(response)
  );
};

export const ProjectExistsWithName = (projectName) => {
  let token = getToken();
  let myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);

  let requestOptions = {
    method: "POST",
    headers: myHeaders,
    redirect: "follow",
  };

  return fetch(
    NEW_API_URL +
      "projects/checkprojectname?projectName=" +
      encodeURIComponent(projectName),
    requestOptions
  ).then((response) => APIParser(response));
};


export const UpdateProjectEndDate = (data) => {
    return triyoAPI.patch(`/Projects/UpdateProjectEndDate`, data, config("PATCH"));
};

export const UpdateProjectTasksEndDate = (data) => {
    return triyoAPI.patch(`/Projects/UpdateProjectTasksEndDate`, data, config("PATCH"));
};

export const UpdateProjectAndTasksEndDate = (data) => {
    return triyoAPI.patch(`/Projects/UpdateProjectAndTasksEndDate`, data, config("PATCH"));
};
export const GetUserProjectsForTaskList = () => {
    return triyoAPI.get("/projects/getuserprojects", config());
}

export const GetUserProjectsForTaskCreateEdit = () => {
  return triyoAPI.get("/projects/GetUserProjectsForTaskCreateEdit", config());
}

export const GetProjectMembersAndGroups = (projectId) => {
  return triyoAPI.get(`/Projects/GetProjectMembersAndGroups?ProjectId=${projectId}`, config());
};  

export const TransferProjectOwnerShip = (data) => {
  return triyoAPI.post(
    `/Projects/TransferProjectOwnership`,
    data,
    config("POST")
  );
};

export const GetTemplateTaskCount = (projectId, originalOwner) => {
  const queryParams = new URLSearchParams({
    ProjectId: projectId,
    OwnerId: originalOwner,
  }).toString();
  return triyoAPI.get(`/Tasks/GetTemplateTaskCount?${queryParams}`, config());
};

export const GetProjectTasksCount = (projectId) => {
  const queryParams = new URLSearchParams({ ProjectId: projectId }).toString();
  return triyoAPI.get(`/Tasks/GetProjectTasksCount?${queryParams}`, config());
};